function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Calendar View");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M4,0 L10,0 L10,10 L0,10 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z",
  id: "Rectangle"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-3",
  x: 0,
  y: 12.5,
  width: 10,
  height: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M0,25 L10,25 L10,35 L4,35 C1.790861,35 2.705415e-16,33.209139 0,31 L0,25 Z",
  id: "Rectangle-Copy-6"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy",
  x: 12,
  y: 0,
  width: 10,
  height: 10
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-4",
  x: 12,
  y: 12.5,
  width: 10,
  height: 10
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-7",
  x: 12,
  y: 25,
  width: 10,
  height: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M24,0 L30,0 C32.209139,-4.05812251e-16 34,1.790861 34,4 L34,10 L24,10 L24,0 Z",
  id: "Rectangle-Copy-2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  fill: "#BDBDBD",
  id: "Rectangle-Copy-5",
  x: 24,
  y: 12.5,
  width: 10,
  height: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M24,25 L34,25 L34,31 C34,33.209139 32.209139,35 30,35 L24,35 L24,25 Z",
  id: "Rectangle-Copy-8"
});

function SvgCalendarView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "36px",
    viewBox: "0 0 34 36"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default __webpack_public_path__ + "media/images/calendar-view-72164055.svg";
export { SvgCalendarView as ReactComponent };